export default __webpack_public_path__ + "static/media/recipe-api-modal-sm.2d6466b9.jpg";